import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

export const supabaseConfigured = Boolean(url && anonKey);

// Cliente com a chave publicável (somente leitura, protegida por RLS) —
// seguro pra embutir no bundle do navegador. Escrita fica só na Edge
// Function de importação, com a service role key guardada no servidor.
export const supabase = supabaseConfigured ? createClient(url!, anonKey!, {auth:{storageKey:'zsb-cloud-auth',persistSession:true,autoRefreshToken:true,detectSessionInUrl:false}}) : null;
